var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPleats(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4788)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_625_4788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2251 16.2246C30.9211 12.0811 44.0232 11.7348 68.3511 16.2246",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.49902 80.6451C2.77232 44.0784 2.37031 18.1823 5.83935 12.6455C9.77566 18.082 11.6916 21.3758 13.4744 28.6314C12.6308 48.5169 12.5346 60.0066 12.52 80.6451",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7688 80.4067C16.8197 58.055 16.0971 46.1039 13.4741 28.8701",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07764 12.6456C11.0783 9.59473 13.9735 7.88388 25.4038 4.77197",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3157 80.6451C74.0424 44.0784 74.4444 18.1823 70.9753 12.6455C67.039 18.082 65.1231 21.3758 63.3403 28.6314C64.1839 48.5169 64.2801 60.0066 64.2947 80.6451",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0459 80.4067C59.995 58.055 60.7176 46.1039 63.3406 28.8701",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7371 12.6456C65.7364 9.59473 62.8412 7.88388 51.4109 4.77197",
    stroke: "#333333",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3126 0C26.314 1.76408 25.8778 2.89032 25.4038 5.24909C36.1045 8.41426 41.5523 7.87566 51.4107 4.7719C50.5354 2.7969 50.0558 1.76476 48.5475 0C40.6127 2.15018 35.9459 2.11306 27.3126 0Z",
    stroke: "#333333",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_625_4788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleats);
export default __webpack_public_path__ + "static/media/pleats.c2d014ebbb66d513dda99311d1f8a57e.svg";
export { ForwardRef as ReactComponent };